import axios from 'axios';
// ---- external imports ----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports ----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { RUNNING_ADS_POST_APIS, RUNNING_ADS_PATCH_APIS } from '../endpoints';
// ---- local imports ----

class AdsService {
	hireAd = async (adId, startingTurnDate, gameUserId) => {
		const data = {
			ad: {
				id: adId,
				// eslint-disable-next-line camelcase
				starting_turn_date: startingTurnDate,
				// eslint-disable-next-line camelcase
				game_user_id: gameUserId,
			},
		};

		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/running_ads/${RUNNING_ADS_POST_APIS.HIRE_AD}`,
		});

		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		const { runningAd, notifications } = response.data;
		const normalizedAd = _normalizeBoughtAd(runningAd);
		formattedResponse.data =  { runningAd: normalizedAd, notifications };

		return formattedResponse
	}

	fetchBoughtAds = async (gameUserId) => {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/bought_ads`,
		});

		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}
	
		formattedResponse.data = _normalizeBoughtAds(response.data.running_ads);

		return formattedResponse;
	};

	fetchAvailableAds = async () => {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/ads/available_ads`,
		});

		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		formattedResponse.data = response.data.ads;

		return formattedResponse;
	};

	stopRunningAd = async (runningAdId, endingTurnDate) => {
		const data = {
			// eslint-disable-next-line camelcase
			running_ad: {
				id: runningAdId,
				// eslint-disable-next-line camelcase
				ending_turn_date: endingTurnDate,
			},
		};

		const response = await ApiService.request({
			method: 'PATCH',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/running_ads/${RUNNING_ADS_PATCH_APIS.STOP_RUNNING_AD}`,
		});

		const formattedResponse = formatResponse(response);

		if (!formattedResponse.isSuccess) {
			return formattedResponse;
		}

		formattedResponse.data = true;

		return formattedResponse;
	};
}

const _normalizeBoughtAd = (unNormalizedAd) => {
	const endDate = unNormalizedAd.ending_turn_date === null
		? '...'
		: unNormalizedAd.ending_turn_date;

	return {
		id: unNormalizedAd.id,
		adId: unNormalizedAd.ad_id,
		slug: unNormalizedAd.ad.slug,
		startDate: _formatDate(unNormalizedAd.starting_turn_date),
		endDate: _formatDate(endDate),
		running: unNormalizedAd.running,
		gameUserId: unNormalizedAd.game_user_id,
		type: unNormalizedAd.ad.type,
		price: unNormalizedAd.ad.price,
		benefit: unNormalizedAd.ad.benefit,
		numberOfExtraCustomers: unNormalizedAd.ad.number_of_extra_customers,
	};
};

const _normalizeBoughtAds = (boughtAds) => {
	return boughtAds && boughtAds.length > 0 ? boughtAds.map(_normalizeBoughtAd) : [];
};

const _formatDate = (unformattedDate) => {
	const formattedDate = new Date(unformattedDate)
		.toLocaleString(
			'en-GB',
			{
				day: '2-digit',
				month: 'short',
				year: '2-digit'
			}
		);
	
	return unformattedDate === '...'
		? unformattedDate
		: formattedDate;
};

export default new AdsService();
